<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" dis-hover style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="modal1=true;detail={}">增加</Button>
          </Col>
          <Col span="5">
             <Input search enter-button placeholder="输入关讲师名称搜索" v-model="serch.key"  @on-search="load"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="lecturerName" label="讲师姓名" width="120" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <Avatar :src="'/api/upload/online/'+scope.row.headImage"/>
            &nbsp;
            {{scope.row.lecturerName}}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="真实姓名" width="80" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="genderShow" label="性别" width="80" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="city" label="常住城市" width="100" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="field" label="擅长领域" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="description" label="一句话简介" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="shortDescription" label="详细介绍" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="count" label="课程数量" :show-tooltip-when-overflow="true"></el-table-column>
        <!--<el-table-column prop="detailedDescription" label="背景简介" :show-tooltip-when-overflow="true"></el-table-column>-->

        <el-table-column prop="msg" label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <a @click="edit(scope.row.id)">编辑</a>
            <cite>|</cite>
            <a @click="remove(scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save"
      @on-cancel="cancel">
      <Form :label-width="100">
				<FormItem label="讲师姓名" required>
					<Input v-model="detail.lecturerName" placeholder="讲师姓名在小程序中显示"/>
				</FormItem>

        <FormItem label="真实姓名" required>
          <Input v-model="detail.name" placeholder="真实姓名小程序不显示"/>
        </FormItem>

				<FormItem label="讲师头像" required>
          <UploadOne v-model="detail.headImage"></UploadOne>
          图片大小：250*250 像素 ，大小：30KB以内
				</FormItem>

        <FormItem label="一句话简介" required>
          <Input v-model="detail.description"/>
        </FormItem>

				<FormItem label="性别" required>
          <Select v-model="detail.genderShow">
            <Option value="男" label="男"></Option>
            <Option value="女" label="女"></Option>
          </Select>
				</FormItem>

				<FormItem label="讲师常住城市">
          <Field :type="3" :addbtn="true" v-model="detail.city"></Field>
				</FormItem>
				<!--<FormItem label="讲师标签">-->
					<!--<Input v-model="detail.tag"/>-->
				<!--</FormItem>-->
				<FormItem label="擅长领域">
					<Input v-model="detail.field"/>
          多个领域用英文逗号分隔：,
				</FormItem>
				<!--<FormItem label="讲师标题">-->
					<!--<Input v-model="detail.title"/>-->
				<!--</FormItem>-->

				<FormItem label="详细介绍">
          <Input v-model="detail.shortDescription" type="textarea" :autosize="{minRows: 5,maxRows: 15}" placeholder="简单介绍"></Input>
				</FormItem>
				<!--<FormItem label="详细简介">-->
          <!--<Input v-model="detail.detailedDescription" type="textarea" :autosize="{minRows: 5,maxRows: 15}" placeholder="详细简介"></Input>-->
          <!--在讲师详情页展示-->
				<!--</FormItem>-->
      </Form>
    </Modal>

  </div>
</template>

<script>

  import Field from '@/components/common/field/Field'
  import UploadOne from '@/public/upload/UploadOne'
  export default {
    components:{UploadOne,Field},
    data(){
      return{
        baseUrl:'/api/lecturer/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        loading:false,
      }
    },
    methods:{
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.lecturerName@like@'+this.serch.key);
        }
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lecturer/Lecturer.vue